var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"stats",attrs:{"id":"stats"}},[_c('h2',{staticClass:"text-center p-3"},[_vm._v("Seguimos avanzando")]),_c('b-row',_vm._l((_vm.stats),function(stat){return _c('b-col',{key:stat.id,staticClass:"text-center stat-item"},[_c('div',[_vm._v(_vm._s(stat.value))]),_c('small',[_vm._v(_vm._s(stat.label))])])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }